import { compose } from 'ramda';

import { saveReturnPath } from '#src/store/location/actions';

import { anonymousOnly } from '../guards';

export const path = '/glp-won/:gameId/signup';
export const component = 'GlpWonSignup';

export const thunk = () => (dispatch, getState) => {
  if (anonymousOnly(dispatch, getState)) return;
  compose(dispatch, saveReturnPath)();
};
